const PlaceholderLoader = () => {
    return (
        <div className="flex w-full animate-pulse flex-col space-y-8" data-testid="loading-data">
            <div>
                <span className="mb-4 block h-full min-h-[0.875rem] w-1/3 rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <span className="block h-full min-h-12 w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
            <div>
                <span className="mb-4 block h-full min-h-[0.875rem] w-1/3 rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <span className="block h-full min-h-12 w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
            <div>
                <span className="mb-4 block h-full min-h-[0.875rem] w-1/3 rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <span className="block h-full min-h-12 w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
            <div>
                <span className="mb-4 block h-full min-h-[0.875rem] w-1/3 rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
                <span className="block h-full min-h-12 w-full rounded-md bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            </div>
        </div>
    );
};

export default PlaceholderLoader;
